
import { CREATE_ADMINISTERED, FETCH_ADMINISTEREDS, UPDATE_ADMINISTEREDS, DELETE_ADMINISTEREDS, } from '../actions';
import { deleteAdministereds } from '../actions/administered';
const initialState = {
//   selectedToDelete: null,
//   selectedToEdit: null,
  setAdministered: null,
  setAdministeredError:null,
//   updateRegType: null,
//   updateDefaultType: null,
  administeredList: [],
  administeredListError:null,
  loading: false,
  updatedAdministered: {},
  deletedAdministered: {},
}

function administeredTypeReducer(state = initialState, action) {
  let setAdministered,
    administeredList,
    updatedAdministered,
    deletedAdministered;

  switch (action.type) {
    case `${CREATE_ADMINISTERED}_PENDING`:
    case `${FETCH_ADMINISTEREDS}_PENDING`:
      return { ...state, setAdministeredError: null, administeredListError: null, loading: true };

    case `${CREATE_ADMINISTERED}_FULFILLED`:
      setAdministered = action.payload.data;
      return { ...state, loading: false, setAdministered };

    case `${FETCH_ADMINISTEREDS}_FULFILLED`:
    administeredList = action.payload.data;
      return { ...state, loading: false, administeredList };
    
    case `${UPDATE_ADMINISTEREDS}_FULFILLED`:
      updatedAdministered = action.payload.data;
      return { ...state, updatedAdministered};

    case `${DELETE_ADMINISTEREDS}_FULFILLED`:
      deletedAdministered = action.payload.data;
      return { ...state, deletedAdministered };

    case `${CREATE_ADMINISTERED}_REJECTED`:
      return { ...state ,loading: false, setAdministeredError: action.payload.response.data, state: initialState };
    
    case `${FETCH_ADMINISTEREDS}_REJECTED`:
      return { ...state ,loading: false, administeredListError: action.payload.response.data, state: initialState };
    
    case `${UPDATE_ADMINISTEREDS}_REJECTED`:
      return { ...state ,loading: false, updatedAdministeredError: action.payload.response.data, state: initialState };
    
    case `${DELETE_ADMINISTEREDS}_REJECTED`: 
      return { ...state ,loading: false, deleteddAdministeredError: action.payload.response.data, state: initialState };
      
    default:
      return state;
  }
}

export default administeredTypeReducer;
